import {createRouter, createWebHistory} from 'vue-router'
import articles from '@/router/articles'
import books from '@/router/books'
import exhibitions from '@/router/exhibitions'
import achvmPlans from '@/router/achvmPlans'
import detailEvaluations from '@/router/detailEvaluations'
import accessLogs from '@/router/accessLogs'
import judgementResults from '@/router/judgementResults'
import academic from "@/router/academic"
import teaching from "@/router/teaching"
import service from "@/router/service"
import award from "@/router/award"
import journal from "@/router/journal"
import systemManagement from "@/router/systemManagement";
import print from "@/router/print"
import notice from "@/router/notice";
import codeManagement from "@/router/codeManagement";
import store from "@/store";
import statistics from "@/router/statistics";
import evalManagement from "@/router/evalManagement";
import logManagement from "@/router/logManagement";
import {isNotBlank} from "@/utils";
import s2journal from "@/router/s2journal";

const routes = [
	{
		path: '/',
		name: 'Home',
		component() {
			return import('@/views/DefaultLayout')
		},
		redirect: '/token/check',
		children: [
			articles,
			books,
			exhibitions,
			academic,
			award,
			detailEvaluations,
			journal,
			s2journal,
			achvmPlans,
			accessLogs,
			judgementResults,
			teaching,
			service,
			systemManagement,
			print,
			notice,
			codeManagement,
			statistics,
			evalManagement,
			logManagement,
		],
	},
	{
		path: '/home',
		name: 'HomepageLayout',
		component() {
			return import('@/views/HomepageLayout.vue')
		},
		children: [
			{
				path: '',
				name: 'HomePage',
				component() {
					return import('@/components/homepage/HomePage.vue')
				},
			},
			{
				path:'notice',
				name:'NoticePublicList',
				component(){
					return import('@/components/homepage/notice/NoticePublicList.vue')
				}
			},
			{
				path:'notice/:seqnr',
				name:'NoticePublicDetail',
				component(){
					return import('@/components/homepage/notice/NoticePublicDetail.vue')
				}
			},
		],
	},
	{
		path: '/token',
		name: 'LoginLayout',
		component() {
			return import('@/views/LoginLayout.vue')
		},
		children: [
			{
				path: 'admin/login/:key',
				name: 'AdminLoginPage',
				component() {
					return import('@/components/auth/AdminLoginPage.vue')
				},
			},
			{
				path: '',
				name: 'MoveSSO',
				component() {
					return import('@/components/auth/MoveSSO.vue')
				},
			},
			{
				path: 'setToken',
				name: 'SetTokenResponse',
				component() {
					return import('@/components/auth/SetTokenResponse.vue')
				},
			},
			{
				path: 'check',
				name: 'TokenCheck',
				component() {
					return import('@/components/auth/TokenCheck.vue')
				},
			},
			{
				path: 'logout',
				name: 'LogoutSSO.vue',
				component() {
					return import('@/components/auth/LogoutSSO.vue')
				},
			},
		],
	},
]

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior() {
		return {top: 0}
	},
})

router.beforeEach(async (to, from, next) => {
	if(to.matched.length > 0) {
		let path = to.matched[to.matched.length - 1].path.replaceAll(/\/\:\w+/ig, '');
		if(path === '/home/notice') path = '/home';
		if(path !== '/' && !path.startsWith('/token')) {
			if(store.getters['menu/checkPermitMenu'](path)) {
				store.commit('menu/pageInit', path);
			}
			else {
				alert('접근권한이 없는 페이지 입니다.');
				if(isNotBlank(store.getters['token/REFRESH_TOKEN'])) await router.push({path:'/home'});
				else await router.push({path:'/token/check'});
			}
		}
	}else {
		alert('존재하지 않는 페이지 입니다.');
		await router.push({path:'/home'});
	}
	next();
})

export default router
